import { useSelector } from 'react-redux';
import { selectOnboardingState } from '../../../../modules/gdp/gdpSlice';

export enum OnboardingState {
  /**
   * In this case we show 'You are not invited yet modal'
   * and prevent user form further apps interactions
   * (we block whole app with this modal until user status became != 'applied' on BE)
   */
  NOT_INVITED = 'NOT_INVITED',

  /**
   * In this case we show 'Team video' once, then app call an api to
   * make showOnboardingTutorial=false on BE
   */
  SHOW_VIDEO = 'SHOW_VIDEO',

  /**
   * In this case we show 'Has to book onboarding modal when user logs in or clicks
   * on add case buttons'
   */
  HAS_TO_BOOK_ONBOARDING = 'HAS_TO_BOOK_ONBOARDING',

  /**
   * In this case no further actions required - no popups or something else
   */
  FINISHED = 'FINISHED',
}

export const useOnboardingState = (): OnboardingState => {
  const { status, isOnboardMeetingBooked, showOnboardingTutorial, isLoading } = useSelector(selectOnboardingState);

  if (isLoading) {
    return OnboardingState.FINISHED;
  }

  if (status === 'applied') {
    return OnboardingState.NOT_INVITED;
  }

  if (showOnboardingTutorial) {
    return OnboardingState.SHOW_VIDEO;
  }

  if (!isOnboardMeetingBooked) {
    return OnboardingState.HAS_TO_BOOK_ONBOARDING;
  }

  return OnboardingState.FINISHED;
};
